import React from 'react'
import Box from '@mui/material/Box'

function Video({
    videoSrcURL, videoTitle, height, ...props
}) {
    const url = videoSrcURL.includes('vimeo') ? `https://player.vimeo.com/video/${videoTitle}` : `https://www.youtube.com/embed/${videoTitle}`
    return (
        <Box sx={{
            backgroundColor: 'white',
            height: '0',
            paddingBottom: '56.25%',
            position: 'relative',
        }}
        >
            <Box
                sx={{
                    height: '100%',
                    width: '100%',
                    left: '0',
                    position: 'absolute',
                    top: '0',
                }}
            >
                <iframe
                    src={url}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    frameBorder="0"
                    webkitallowfullscreen
                    mozallowfullscreen
                    allowFullScreen
                    height="100%"
                    width="100%"
                />
            </Box>
        </Box>
    )
}
export default Video
